import playerComponents from './async/player'
import browseComponents from './async/browse'
import VueTheMask from 'vue-the-mask'
import PortalVue from 'portal-vue'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'

const componentsRequire = require.context('.', true, /^\.(?!\/async)\/.*\.vue$/)

const components = {}
componentsRequire.keys().forEach(filename => {
  const component = componentsRequire(filename).default
  components[component.name] = component
})

export default {
  install(Vue) {
    Object.entries(components).forEach(entry => Vue.component(entry[0], entry[1]))
    Vue.use(playerComponents)
    Vue.use(browseComponents)
    Vue.use(VueTheMask)
    Vue.use(PortalVue)
    Vue.component('dynamic-scroller', DynamicScroller)
    Vue.component('dynamic-scroller-item', DynamicScrollerItem)
  }
}
